<div class="main-container d-flex flex-column justify-content-end">
    <div>
        <!--        <div class="title">Forward</div>-->
        <!--        <div class="title closer">backward</div>-->
        <!--        <p class="pt-3">Audioguide créé par Marcelline Delbecq et Eric Chenaux pour le bassin de la Garonne</p>-->
        <!--        <p>En écoute du 17 Septembre au 17 Octobre</p>-->
        <!--        <p>Mixage: Cyril Harrison<br>Remerciements: Katinka Bock et Gyan Panchal</p>-->
        <!--        <p><a href="https://www.printempsdeseptembre.com/fr/le-festival/marcelline-delbecq-eric-chenaux/1153">Voir plus</a></p>-->
        <!--        <img class="logo" src="assets/logo-printemps.png"/>-->
        <div class="h-100">
            <div class="p-4">
                <div class="title">Forward</div>
                <div class="title closer">backward</div>
                <p class="pt-3">Audioguide créé par Marcelline Delbecq et Eric Chenaux pour le bassin de la Garonne</p>
                <p>En écoute du 17 Septembre au 17 Octobre</p>
                <p>Mixage: Cyril Harrison<br>Remerciements: Katinka Bock et Gyan Panchal</p>
                <p><a href="https://www.printempsdeseptembre.com/fr/le-festival/marcelline-delbecq-eric-chenaux/1153">Voir
                    plus</a></p>
                <img class="logo" src="assets/logo-printemps.png"/>
            </div>
            <mat-advanced-audio-player #audioPlayer class="h-100"
                              [playlist]="playlist"
                              [displayTitle]="false"
                              [displayVolumeControls]="true"
                              [displayRepeatControls]="false"
                              [disablePositionSlider]="false"
                              [displayArtist]="false"
                              [displayDuration]="true"
                              [autoPlay]="false"

                              [expanded]="true">
            </mat-advanced-audio-player>
        </div>
    </div>
</div>
